<template>
  <div class="sigpadbox">
    <div class="sig-pad-desktop">
      <VueSignaturePad
        :width="padWidth"
        :height="padHeight"
        ref="signaturePad"
        id="signature"
        :options="options"
      />
    </div>

    <div class="sigpadbuttons">
      <md-button class="md-info md-sm" @click="undo">Undo</md-button>
      <md-button class="md-success md-sm" @click="save">Save Signature</md-button>
      <p v-if="showInvalid" class="showinv">You must sign in the box before saving</p>
      <p v-if="showSave">Your signature has been saved</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MySignaturePad',
  data() {
    return{
      options: {
        penColor: "#bb1719"
      },
      showInvalid: false,
      showSave: false
    }
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // console.log('here');

      if (!isEmpty) {
        this.showInvalid = false;
        this.$emit('saveSig', data);
        this.showSave = true;
      } else {
        this.showInvalid = true;
      }
    }
  },
  computed: {
    padWidth() {
      if (window.screen.width < 800) {
        console.log('sm')
        return "300px"
      } else {
        console.log('lg')
        return "100%"
      }
    },
    padHeight(){
      if (window.screen.width < 800) {
        return "200px"
      } else {
        return "300px"
      }
    }
  }
};
</script>

<style lang="scss">
  #signature {
    border: solid 2px #005B86;
  }

  .sigpadbox {
    margin-bottom: 15px;
    margin-top: 10px;
  }

  .sigpadbuttons {
    .md-button {
      margin-right: 5px;
    }
    p {
      display: inline-block;
    }
    .showinv {
      color: #c20c0c;
    }
  }

  // .sig-pad-mobile {
  //   display: none;
  // }
  //
  // @media (max-width: 500px) {
  //   .sig-pad-desktop{
  //     display: none;
  //   }
  //
  //   .sig-pad-mobile {
  //     display: inherit;
  //   }
  // }
</style>
